import { render, staticRenderFns } from "./handover.vue?vue&type=template&id=0cdf60ec&scoped=true&"
import script from "./handover.vue?vue&type=script&lang=js&"
export * from "./handover.vue?vue&type=script&lang=js&"
import style0 from "./handover.vue?vue&type=style&index=0&lang=css&"
import style1 from "./handover.vue?vue&type=style&index=1&id=0cdf60ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cdf60ec",
  null
  
)

export default component.exports